<template>
    <div>
      <div class="row">
        <div class="col-md-12 mt-3">
          <div
            class="form-row"
            v-for="(inputJenis, index) in jenisPemeriksaan"
            :key="index"
          >
            <div class="form-group col-md-5 mb-0">
              <label class="">Jenis Pemeriksaan Penunjang</label>
            </div>
            <div class="form-group col-md-5 mb-0">
              <label class="ml-1" v-if="inputJenis.selectedJenis && inputJenis.selectedJenis.value == 'radiologiFoto'">Unggah Hasil Pemeriksaan Penunjang Radiologi<span class="text-danger">*</span></label>
              <label class="ml-1" v-else-if="inputJenis.selectedJenis && inputJenis.selectedJenis.value == 'pemeriksaanLain'">Jenis Pemeriksaan Penunjang</label>
              <label class="ml-1" v-else>Hasil</label>
            </div>
            <div class="form-group col-md-5">
              <div class="media">
                <div class="media-body pr-0">
                  <vue-select-clearable
                    class="select_jenis_pemeriksaan"
                    :options="getFilteredOptions(index)"
                    v-model="inputJenis.selectedJenis"
                    placeholder="Pilih"
                    @input="handleSelectedJenis(index)"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.label }}
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      {{ option.label }}
                    </template>
                  </vue-select-clearable>
                </div>
              </div>
            </div>
            <div class="form-group col-md-6 pl-2" v-if="inputJenis.selectedJenis && inputJenis.selectedJenis.value == 'radiologiFoto'">
              <div id="upload-box-jenis" class="row justify-content-md-center" v-if="selectedFilesIndex.length == 0">
                <template>
                  <b-button variant="dark" size="sm"  @click="triggerAction(index)">
                    <span class="btn-wrapper--icon">
                      <font-awesome-icon icon="camera" />
                    </span>
                    <span class="btn-wrapper--label">Dari Kamera</span>
                  </b-button>
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style="display:none"
                    :ref="'cameraInput-' + index"
                    @change="onImageCapturedIndex"
                  />
                  <div class="col-md-auto">Atau</div>
                  <b-button variant="dark" size="sm" @click="triggerFileInput(index)">
                    <span class="btn-wrapper--icon">
                      <font-awesome-icon icon="folder" />
                    </span>
                    <span class="btn-wrapper--label">Cari File</span>
                  </b-button>
                  <input
                    type="file"
                    @change="onFileSelectedIndex"
                    @click="resetFileInputIndex(index)"
                    style="display:none"
                    :ref="'fileInput-' + index"
                  />
                </template>
              </div>
              <div
                v-else
                v-for="(item, i) in selectedFilesIndex"
                :key="item.index"
                class="row file-upload-index"
              >
                <div class="col-md-4">
                  <label class="text-break">{{ item.name }}</label>
                </div>
                <div class="col-md-2">
                  <label>{{ Math.round(item.size / 1000) }} KB</label>
                </div>
                <div class="col-md-3">
                  <b-progress :max="100">
                    <b-progress-bar
                      :value="fileProgress[item.name]"
                      :label="`${Math.round(fileProgress[item.name])}%`"
                    ></b-progress-bar>
                  </b-progress>
                </div>
                <div class="col-md-3">
                  <div class="row d-flex justify-content-end mr-1">
                    <!-- :href="item.url" -->
                    <a @click.prevent="donwloadImage(item)" v-if="item.from_api">
                      <font-awesome-icon
                        icon="download"
                        class="font-size-lg grow icon"
                        style="margin-right:10px"
                      />
                    </a>
                    <a v-else @click="downloadFile(item)">
                      <font-awesome-icon
                        icon="download"
                        class="font-size-lg grow icon"
                        style="margin-right:10px"
                      />
                    </a>
                    <font-awesome-icon
                      icon="eye"
                      class="font-size-lg grow icon"
                      style="margin-right:10px"
                      v-if="isShow(item)"
                      @click="readFile(item)"
                    />
                    <font-awesome-icon
                      icon="trash"
                      class="font-size-lg grow icon"
                      @click="removeFileIndex(item, i)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <template v-else>
              <div class="form-group col-md-6 pl-2" v-if="inputJenis.selectedJenis && inputJenis.selectedJenis.value == 'pemeriksaanLain'">
                <input
                  placeholder="Tulis Jenis Pemeriksaan Penunjang"
                  type="text"
                  class="form-control"
                  :value="inputJenis.jenis_lain"
                  @input="
                    event => {
                      inputJenis.jenis_lain = event.target.value;
                      setInputJenis()
                    }
                  "
                />
              </div>
              <div class="form-group col-md-6 pl-2" v-else>
                <input
                  placeholder="Tulis Hasil Pemeriksaan"
                  type="text"
                  class="form-control"
                  :value="inputJenis.hasil"
                  @input="
                    event => {
                      inputJenis.hasil = event.target.value;
                      setInputJenis()
                    }
                  "
                />
              </div>
            </template>
            <div class="form-group col-md-1 d-flex align-items-start mt-2">
              <div class="mb-1">
                <b-button
                  variant="danger"
                  style="padding: 0.1rem 0.3rem;border-radius: 100%;"
                  @click="removeJenis(index)"
                  
                >
                  <font-awesome-icon icon="minus" />
                </b-button>
                <b-button
                  variant="first"
                  style="padding: 0.1rem 0.3rem;border-radius: 100%;background-color: #01a8e5;border-color: transparent;margin-left: 0.3rem;"
                  @click="addInputJenis()"
                >
                  <font-awesome-icon icon="plus" />
                </b-button>
              </div>
            </div>
            <template v-if="inputJenis.selectedJenis && inputJenis.selectedJenis.value == 'pemeriksaanLain'">
              <div class="form-group col-md-5 mb-0">
                <label class="ml-1">Hasil</label>
              </div>
              <div class="form-group col-md-7 mb-0"></div>
              <div class="form-group col-md-5 pl-1">
                <input
                  placeholder="Tulis Hasil Pemeriksaan"
                  type="text"
                  class="form-control"
                  :value="inputJenis.hasil"
                  @input="
                    event => {
                      inputJenis.hasil = event.target.value;
                      setInputJenis()
                    }
                  "
                />
              </div>
            </template>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-6">
          <label>* Unggah Hasil Pemeriksaan Penunjang (maks. 5 file)</label>
        </div>
      </div>
  
      <div id="upload-box" class="row justify-content-md-center">
        <template v-if="!activateCamera">
          <b-button variant="dark" @click="determineAction">
            <span class="btn-wrapper--icon">
              <font-awesome-icon icon="camera" />
            </span>
            <span class="btn-wrapper--label">Dari Kamera</span>
          </b-button>
          <input
            type="file"
            accept="image/*"
            capture="environment"
            style="display:none"
            ref="cameraInput"
            @change="onImageCaptured"
          />
          <div class="col-md-auto">Atau</div>
          <b-button variant="dark" @click="$refs.fileInput.click()">
            <span class="btn-wrapper--icon">
              <font-awesome-icon icon="folder" />
            </span>
            <span class="btn-wrapper--label">Cari File</span>
          </b-button>
          <input
            type="file"
            @change="onFileSelected"
            @click="resetFileInput"
            style="display:none"
            ref="fileInput"
            multiple="multiple"
          />
        </template>
        <template v-else>
          <web-cam
            class="my-3"
            ref="webcam"
            @started="onStarted"
            @stopped="onStopped"
            @error="onError"
            @cameras="onCameras"
            @camera-change="onCameraChange"
            :device-id="deviceId"
          />
          <b-button variant="dark" @click="onCapture">
            <span class="btn-wrapper--icon">
              <font-awesome-icon icon="camera" />
            </span>
            <span class="btn-wrapper--label text-capitalize">ambil gambar</span>
          </b-button>
        </template>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label style="font-style:italic"
            >Format yang digunakan: jpeg, jpg, png, pdf, doc, excel maks. 2MB.</label
          >
        </div>
      </div>
      <br />
      <div class="row" v-if="selectedFiles.length > 0">
        <div class="col-md-6">
          <label>Hasil Pemeriksaan Penunjang</label>
        </div>
      </div>
      <div
        v-for="(item, index) in selectedFiles"
        :key="item.index"
        class="row file-upload"
      >
        <div class="col-md-4">
          <label class="text-break">{{ item.name }}</label>
        </div>
        <div class="col-md-2">
          <label>{{ item.size / 1000 }} KB</label>
        </div>
        <div class="col-md-3">
          <b-progress :max="100">
            <b-progress-bar
              :value="fileProgress[item.name]"
              :label="`${Math.round(fileProgress[item.name])}%`"
            ></b-progress-bar>
          </b-progress>
        </div>
        <div class="col-md-3">
          <div class="row d-flex justify-content-end mr-2">
            <!-- :href="item.url" -->
            <a @click.prevent="donwloadImage(item)" v-if="item.from_api">
              <font-awesome-icon
                icon="download"
                class="font-size-xl grow icon"
                style="margin-right:20px"
              />
            </a>
            <a v-else @click="downloadFile(item)">
              <font-awesome-icon
                icon="download"
                class="font-size-xl grow icon"
                style="margin-right:20px"
              />
            </a>
            <font-awesome-icon
              icon="eye"
              class="font-size-xl grow icon"
              style="margin-right:20px"
              v-if="isShow(item)"
              @click="readFile(item)"
            />
            <font-awesome-icon
              icon="trash"
              class="font-size-xl grow icon"
              @click="removeFile(item, index)"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <div class="row d-flex justify-content-end mr-2">
            <font-awesome-icon
              icon="eraser"
              class="font-size-xl m-2 grow icon"
              v-on:click="setDrawPostData('eraser')"
              v-show="!isHidden"
              :class="{ active_tool: isActive === 'eraser' }"
            />
            <font-awesome-icon
              icon="pen-alt"
              class="font-size-xl m-2 grow icon"
              v-on:click="setDrawPostData('pen')"
              :class="{ active_tool: isActive === 'pen' }"
            />
            <font-awesome-icon
              icon="keyboard"
              class="font-size-xl m-2 grow icon"
              v-on:click="setDrawPostData('keyboard')"
              :class="{ active_tool: isActive === 'keyboard' }"
            />
          </div>
          <div class="row d-flex justify-content-end mr-2">
            <div>
              <input
                type="range"
                class="custom-range"
                min="1"
                max="50"
                v-model.number="penWidth"
              />
            </div>
          </div>
          <div class="row d-flex justify-content-end mr-2">
            <div>
              <span
                @click="
                  penColor('blue');
                  isColorActive = 'blue';
                "
                class="dot grow"
                style="background-color: blue;"
                :class="{ color_active: isColorActive === 'blue' }"
              ></span>
              <span
                @click="
                  penColor('red');
                  isColorActive = 'red';
                "
                class="dot grow"
                style="background-color: red;"
                :class="{ color_active: isColorActive === 'red' }"
              ></span>
              <span
                @click="
                  penColor('#54c756');
                  isColorActive = 'green';
                "
                class="dot grow"
                style="background-color: #54c756;"
                :class="{ color_active: isColorActive === 'green' }"
              ></span>
              <span
                @click="
                  penColor('#555');
                  isColorActive = 'black';
                "
                class="dot grow"
                style="background-color: #555;"
                :class="{ color_active: isColorActive === 'black' }"
              ></span>
              <span
                @click="
                  penColor('orange');
                  isColorActive = 'yellow';
                "
                class="dot grow"
                style="background-color: orange;"
                :class="{ color_active: isColorActive === 'yellow' }"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>Keterangan :</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" v-show="!isHidden">
          <canvas
            id="pemeriksaan_penunjang-canvas"
            ref="canvas"
            @mousedown="handleMousedown"
            @mouseup="handleMouseup"
            @mousemove="handleMousemove"
            @touchstart="handleTouchstart"
            @touchend="handleTouchend"
            @touchmove="handleTouchmove"
            width="1100"
            height="500"
            >Your browser does not support the HTML 5 Canvas.</canvas
          >
          <div class="col-md-4">
            <b-button @click="clear" variant="warning" size="sm" class="m-1"
              >Clear</b-button
            >
          </div>
        </div>
        <div class="col-md-12" v-show="isHidden">
          <label></label>
          <Editor :editorContent="penunjang" v-on:update-content="updateContent" />
        </div>
        <div v-show="!isHidden" class="col-md-12">
          <div id="img_pemeriksaan_penunjang"></div>
        </div>
      </div>
      <!-- Modal Camera -->
      <b-modal
        ref="modal-camera"
        size="lg"
        hide-header
        hide-footer
        :no-close-on-backdrop="true"
      >
        <b-row>
          <b-col sm="10 px-4">
            <ol class="breadcrumb font-size-xs p-0">
              <li class="breadcrumb-item font-weight-bold text-primary">
                Rekam Medis
              </li>
              <li class="breadcrumb-item active">Camera</li>
            </ol>
            <label class="display-4 mb-3 font-weight-bold">Camera</label>
          </b-col>
          <b-col sm="2" class="text-right">
            <a @click.prevent="closeModal" class="pointer">
              Close
            </a>
          </b-col>
        </b-row>
        <b-card class="card-shadowless card-info">
          <b-row class="">
            <b-col sm="12" class="text-center" v-if="activeCameraIndex">
              <web-cam
                class="my-3"
                ref="webcamera"
                @started="onStarted"
                @stopped="onStopped"
                @error="onError"
                @cameras="onCameras"
                @camera-change="onCameraChange"
                :device-id="deviceId"
              />
              <b-button variant="dark" @click="onCaptureIndex">
                <span class="btn-wrapper--icon">
                  <font-awesome-icon icon="camera" />
                </span>
                <span class="btn-wrapper--label text-capitalize">ambil gambar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-modal>
      <!-- End Modal Camera -->

    </div>
    
  </template>
  
<script>
  import { mapActions, mapGetters } from 'vuex';
  import { ImageCompressor } from 'compressor-img';
  import { WebCam } from 'vue-web-cam';
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { faPlus, faMinus} from '@fortawesome/free-solid-svg-icons';
  library.add(faPlus, faMinus);
  
  export default {
    name: 'ObjectivePemeriksaanPenunjang',
    components: {
      WebCam,
      Editor: () => import('./Editor.vue'),
      'vue-select-clearable': () => import('@/components/VueSelectClearable.vue'),
    },
    data() {
      return {
        isDrawing: false,
        isHidden: true,
        drawing: false,
        mousePos: { x: 0, y: 0 },
        lastPos: { x: 0, y: 0 },
        ctx: null,
        isLoading: false,
        isPen: false,
        isActive: 'keyboard',
        isColorActive: 'black',
        penWidth: 2,
        selectedFiles: [],
        fileProgress: [],
        promises: [],
        fileReaderPromises: [],
        uploadedFiles: [],
        supportedFiles: ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx'],
        camera: null,
        devices: [],
        deviceId: null,
        activateCamera: false,
        ediRekamMedis: {},
        penunjang: null,
        imgPenunjang: null,
        jenisPemeriksaan: [
          {
            selectedJenis: null,
            hasil: null,
          }
        ],
        optionJenisPemeriksaan: [
          {
            label: 'Radiologi (Foto)',
            value: 'radiologiFoto',
          },
          {
            label: 'Darah Rutin Hemoglobin',
            value: 'darahRutinHemo',
          },
          {
            label: 'Darah Rutin Leukosit',
            value: 'darahRutinLeu',
          },
          {
            label: 'Darah Rutin Eristrosit',
            value: 'darahRutinErit',
          },
          {
            label: 'Darah Rutin Hematrokit',
            value: 'darahRutinHema',
          },
          {
            label: 'Darah Rutin Trombosit',
            value: 'darahRutinTrom',
          },
          {
            label: 'Darah Rutin Lanjutan',
            value: 'darahRutinLaju',
          },
          {
            label: 'Lemak Darah HDL',
            value: 'lemakDarahHDL',
          },
          {
            label: 'Lemak Darah LDL',
            value: 'lemakDarahLDL',
          },
          {
            label: 'Lemak Darah Cholestrol',
            value: 'lemakDarahChol',
          },
          {
            label: 'Lemak Darah Trigliserida',
            value: 'lemakDarahTrigli',
          },
          {
            label: 'Gula Darah Sewaktu',
            value: 'gulaDarahSewaktu',
          },
          {
            label: 'Gula Darah Puasa',
            value: 'gulaDarahPuasa',
          },
          {
            label: 'Gula Darah Post Prandial',
            value: 'gulaDarahPostPrandial',
          },
          {
            label: 'Gula Darah HBA1C',
            value: 'gulaDarahHbA1c',
          },
          {
            label: 'Fungsi Hati SGOT',
            value: 'fungsiHatiSGOT',
          },
          {
            label: 'Fungsi Hati SGPT',
            value: 'fungsiHatiSGPT',
          },
          {
            label: 'Fungsi Hati Gamma',
            value: 'fungsiHatiGamma',
          },
          {
            label: 'Fungsi Hati Prot Kual',
            value: 'fungsiHatiProtKual',
          },
          {
            label: 'Fungsi Hati Albumin',
            value: 'fungsiHatiAlbumin',
          },
          {
            label: 'Fungsi Ginjal Crea',
            value: 'fungsiGinjalCrea',
          },
          {
            label: 'Fungsi Ginjal Ureum',
            value: 'fungsiGinjalUreum',
          },
          {
            label: 'Fungsi Ginjal Asam',
            value: 'fungsiGinjalAsam',
          },
          {
            label: 'Fungsi Jantung ABI',
            value: 'fungsiJantungABI',
          },
          {
            label: 'Fungsi Jantung EKG',
            value: 'fungsiJantungEKG',
          },
          {
            label: 'Fungsi Jantung Echo',
            value: 'fungsiJantungEcho',
          },
          {
            label: 'Fundus Kopi',
            value: 'funduskopi',
          },
          {
            label: 'Pemeriksaan Penunjang Lainnya',
            value: 'pemeriksaanLain',
          },
        ],
        selectedFilesIndex: [],
        uploadedFilesIndex: [],
        supportedFilesIndex: ['png', 'jpg', 'jpeg'],
        fileReaderPromisesIndex: [],
        activeCameraIndex: false,
      };
    },
    computed: {
      ...mapGetters(['getKlinikId']),
      canvas() {
        return this.$refs.canvas;
      },
      selectedJenis() {
        return this.jenisPemeriksaan
          .map(item => item.selectedJenis ? item.selectedJenis.value : null)
          .filter(item => item !== null);
      }
    },
    watch: {
      camera: function(id) {
        this.deviceId = id;
      },
      devices: function() {
        // Once we have a list select the first one
        const [first, ...tail] = this.devices;
        if (first) {
          this.camera = first.deviceId;
          this.deviceId = first.deviceId;
        }
      },
      imgPenunjang() {
        this.imgPenunjangChanged()
      },
      uploadedFilesIndex(newVal, oldVal) {
        if(newVal.length > 0) {
          this.jenisPemeriksaan.map(item => {
            if(item.selectedJenis && item.selectedJenis.value == 'radiologiFoto') {
              item.hasil = newVal[0]
              return item
            }
          })
        } else {
          this.jenisPemeriksaan.map(item => {
            if(item.selectedJenis && item.selectedJenis.value == 'radiologiFoto') {
              item.hasil = null
              return item
            }
          })
        }

        this.setInputJenis()
      }
    },
    methods: {
      isShow(d) {
        if(d.name != undefined) {
          const accept = [
            'jpeg', 'jpg', 'png',
            'JPEG', 'JPG', 'PNG',
            'gif', 'pdf',
          ]
          let ext = d.uploaded_name != null ? d.uploaded_name.split('.').pop() : d.name.split('.').pop()
          if(accept.includes(ext)) return true
          else return false
        } else {
          return false
        }
      },
      setPenunjangData(d) {
        if(d.pemeriksaan_penunjang.is_draw) {
          this.penunjang = d.pemeriksaan_penunjang.notes
          if(d.pemeriksaan_penunjang.draw_path != null) this.imgPenunjang = d.pemeriksaan_penunjang.draw_path;
        } else {
          this.penunjang = d.pemeriksaan_penunjang.notes
        }
        if(
            d.pemeriksaan_penunjang.files != null
            && d.pemeriksaan_penunjang.files != 'null'
          ) {
          const files = JSON.parse(d.pemeriksaan_penunjang.files)
          files.map(item => {
            if(item.name != undefined) {
              this.$set(this.fileProgress, item.name, 100);
              this.selectedFiles.push({
                name: item.name,
                size: item.size,
                file: item.url || item.file,
                url: item.url || item.file,
                from_api: true,
                uploaded_name: item.uploaded_name,
              })
            }
          })
        }

        if (d.bpjs_mcu && d.bpjs_mcu.data.length > 0) {
          this.jenisPemeriksaan = d.bpjs_mcu.data
          d.bpjs_mcu.data.map(item => {
            if(item.selectedJenis && item.selectedJenis.value == 'radiologiFoto') {
              if (item.hasil) {
                this.$set(this.fileProgress, item.hasil.name, 100);
                this.selectedFilesIndex.push({
                  name: item.hasil.name,
                  size: item.hasil.size,
                  file: item.hasil.url || item.hasil.file,
                  url: item.hasil.url || item.hasil.file,
                  from_api: true,
                  uploaded_name: item.hasil.uploaded_name,
                })
              }
            }

            return item
          })
        }
      },
      imgPenunjangChanged() {
        let self = this;
        self.image_url = self.imgPenunjang;
        self.clear();
        self.drawBackground(self.image_url);
      },
      // draw the image
      drawBackground(image_url) {
        let self = this;
        let canvas = document.getElementById('pemeriksaan_penunjang-canvas'),
          ctx = canvas.getContext('2d'),
          img_pemeriksaan_penunjang = document.getElementById('img_pemeriksaan_penunjang');
        let backgroundURL = image_url;
  
        let background = new Image();
        background.crossOrigin = 'Anonymous';
        background.src = backgroundURL;
  
        //remove existing image
        if (img_pemeriksaan_penunjang.hasChildNodes()) {
          img_pemeriksaan_penunjang.innerHTML = '';
        }
  
        background.onload = function() {
          let newSize = { width: background.width, height: background.height };
          ctx.drawImage(background, 0, 0, newSize.width, newSize.height);
        };
        this.isDrawing = true;
      },
      determineAction() {
        //cek batas upload file
        if (this.selectedFiles.length >= 5) {
          this.$swal({
            type: 'error',
            title: 'File Telah Mencapai Batas Maksimal',
            text: 'Anda hanya bisa mengunggah 5 file dalam 1x visit pasien!'
          });
          return;
        }

        if (this.isMobile()) {
          this.$refs.cameraInput.click();
        } else {
          this.activateCamera = true;
          this.$nextTick(this.onStart);
        }
      },
      onCapture() {
        this.processWebcamImage(this.$refs.webcam.capture());
        this.activateCamera = false;
        this.onStop();
      },
      processWebcamImage(x) {
        fetch(x)
          .then(res => res.blob())
          .then(blob => {
            this.selectedFiles.push({
              name: `webcam_captured_${+new Date()}`,
              file: blob,
              size: blob.size
            })
          })
          .then(this.processUpload);
      },
      onStarted(stream) {},
      onStopped(stream) {},
      onStop() {
        this.$refs.webcam.stop();
      },
      onStart() {
        this.$refs.webcam.start();
      },
      onError(error) {
        this.$swal({
          type: 'error',
          title: 'Camera access denied',
          text: error
        });
      },
      onCameras(cameras) {
        this.devices = cameras;
      },
      onCameraChange(deviceId) {
        this.deviceId = deviceId;
        this.camera = deviceId;
      },
      ...mapActions(['updatePostData', 'updateCanvas']),
      updateContent(content) {
        this.updatePostData({
          key: 'pemeriksaan_penunjang_text',
          value: content
        });
      },
  
      //check is last item on loop
      isLastItem(index) {
        if (index === this.selectedFiles.length - 1) {
          return true;
        }
        return false;
      },
      //convert b64 to blob
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
  
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
  
        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
  
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
  
          var byteArray = new Uint8Array(byteNumbers);
  
          byteArrays.push(byteArray);
        }
  
        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      //check image files or not
      isFileImage(file) {
        const acceptedImageTypes = [
          'image/gif',
          'image/jpeg',
          'image/png',
          'image/jpg'
        ];
        return file && acceptedImageTypes.includes(file['type']);
      },
      resetFileInput() {
        const x = this.$refs.fileInput;
        x.value = '';
      },
      //on file selected handler
      async onFileSelected(event) {
        const {
          target: { files }
        } = event;
        this.fileReaderPromises = [];
  
        if (
          this.selectedFiles.some(x =>
            Object.keys(files)
              .filter(item => item !== 'length')
              .some(item => files[item].name === x.name)
          )
        ) {
          this.$swal({
            type: 'error',
            text: 'Anda tidak bisa memasukkan data yang sama!'
          });
          return false;
        }
  
        var a = document.getElementsByClassName('file-upload');
        if (a.length + event.target.files.length > 5) {
          this.$swal({
            type: 'error',
            title: 'File Telah Mencapai Batas Maksimal',
            text: 'Anda hanya bisa mengunggah 5 file dalam 1x visit pasien!'
          });
          return;
        }
  
        for (let i = 0; i < event.target.files.length; i++) {
          if (i == 5 || this.selectedFiles.length == 5) {
            this.$swal({
              type: 'error',
              title: 'File Telah Mencapai Batas Maksimal',
              text: 'Anda hanya bisa mengunggah 5 file dalam 1x visit pasien!'
            });
            return;
          }
          let file = event.target.files[i];
          let extension = file.name.split('.').pop();
  
          if (this.supportedFiles.includes(extension.toLowerCase())) {
            if (this.isFileImage(file)) {
              this.compressImage(file);
            } else {
              file = { name: file.name, file: file, size: file.size, from_api: false };
              this.selectedFiles.push(file);
            }
          } else {
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text:
                'file ' +
                file.name +
                ' not supported, please upload jpeg, jpg, png, pdf, doc, excel file...'
            });
          }
        }
  
        await Promise.all(this.fileReaderPromises)
          .then(res => {
            res.map(item => {
              this.selectedFiles.push(item);
            });
          })
          .then(this.processUpload);
      },
      async processUpload() {
        if (this.selectedFiles.length > 0) {
          this.selectedFiles.map(item => {
            if (!item.isUploading && !item.from_api) {
              this.prepareUpload(item.name, item.file);
              item.isUploading = true;
            }
          });
        }
  
        try {
          await Promise.all(this.promises).then(res => {
            res.map((item, index) => {
              if (!item.data.status) {
                return this.$swal({
                  type: 'error',
                  title: 'Oops...',
                  text: item.data.message
                }).then(() => {
                });
              } else {
                this.uploadedFiles = res.reduce((unique, item) => {
                  return unique.includes(item.data) ? unique : [...unique, item.data];
                }, []);
              }
            });
          });
        } catch(e) {
        }
  
        if (this.selectedFiles.length > 0) {
          this.selectedFiles.map(item => {
            if (item.from_api) {
              this.uploadedFiles.push(item)
            }
          });
        }
  
        this.updatePostData({
          key: 'pemeriksaan_penunjang',
          value: this.uploadedFiles
        });
      },
      //compress if file images
      compressImage(file) {
        this.fileReaderPromises.push(
          new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onloadend = () => {
              let imageCompressor = new ImageCompressor({
                onSuccess: response => {
                  let ImageURL = response.compressed;
                  let block = ImageURL.split(';');
                  let contentType = block[0].split(':')[1];
                  let realData = block[1].split(',')[1];
                  let blob = this.b64toBlob(realData, contentType);
                  resolve({ name: file.name, file: blob, size: blob.size });
                },
                scale: 70,
                quality: 70,
                originalImage: reader.result
              });
            };
            reader.readAsDataURL(file);
          })
        );
      },
      //prepare formData
      prepareUpload(filename, file) {
        let formData = new FormData();
        formData.append('klinik_id', this.getKlinikId)
        formData.append(filename, file);
  
        this.promises.push(
          this.$axios.post('/upload-cloud', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: progressEvent => {
              let progress = (progressEvent.loaded * 100) / progressEvent.total;
              this.$set(this.fileProgress, filename, progress);
            }
          })
          .then(res => {
            if(res.data.status) this.uploadedFiles.push(res.data)
          })
          .catch(e => {
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: `Gagal mengupload ${filename}`
            })
            .then(() => {
              let rmIndex = this.selectedFiles.map(item => {
                return item.name;
              }).indexOf(filename);
              this.selectedFiles.splice(rmIndex, 1);            
            })
          })
        );
      },
      //camera handler
      onImageCaptured(event) {
        //handle image from camera or from disk here...
        this.onFileSelected(event);
      },
      async donwloadImage(item) {
        const a = document.createElement('a');
          a.href = await this.toDataURL(item.url);
          a.download = item.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
      },
      toDataURL(url) {
        return fetch(url).then((response) => {
            return response.blob();
        }).then(blob => {
            return URL.createObjectURL(blob);
        });
      },
      //download selected file
      downloadFile(item) {
        if(item.from_api == true){
          window.open(item.url || item.file, '_blank');
        }else{
          const data = window.URL.createObjectURL(item.file);
          const link = document.createElement('a');
          link.href = data;
          link.download = item.name;
          link.click();
          setTimeout(function() {
            window.URL.revokeObjectURL(data);
          }, 100);
        }
      },
      //view selected file
      readFile(item) {
        if(item.from_api == true) {
          window.open(item.file)
        } else {
          const data = window.URL.createObjectURL(item.file)
          window.open(data)
        }
      },
      //remove selected file
      removeFile(file, index) {
        this.selectedFiles.splice(index, 1);
        this.promises.splice(index, 1);
        let filename = file.name;
        filename = filename.split(' ').join('_');
        filename = filename.split('.').join('_');
  
        if(file.from_api == true) {        
          this.$axios.post('/delete-cloud', {
            filenames: [file.uploaded_name]
          });
  
          this.updatePostData({
            key: 'pemeriksaan_penunjang',
            value: this.selectedFiles
          });
        } else {
          let removeIndex = this.uploadedFiles
            .map(item => {
              return item.name;
            })
            .indexOf(filename);
  
          const doDelete = this.$axios.post('/delete-cloud', {
            filenames: [this.uploadedFiles[removeIndex].uploaded_name]
          });
  
          doDelete.then(res => {
            this.uploadedFiles.splice(removeIndex, 1);
  
            this.updatePostData({
              key: 'pemeriksaan_penunjang',
              value: this.uploadedFiles
            });
          });
        }
      },
  
      handleMousedown(e) {
        this.lastPos = this.getMousePos(e);
        this.ctx.lineWidth = this.penWidth;
        this.drawing = true;
      },
      handleMouseup(e) {
        this.drawing = false;
      },
      handleMousemove(e) {
        this.mousePos = this.getMousePos(e);
        if (this.drawing) {
          this.ctx.beginPath();
          if (this.isPen) {
            this.ctx.globalCompositeOperation = 'source-over';
            this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
            this.ctx.lineTo(this.mousePos.x, this.mousePos.y);
            this.ctx.stroke();
          } else {
            this.ctx.globalCompositeOperation = 'destination-out';
            this.ctx.arc(
              this.mousePos.x,
              this.mousePos.y,
              this.penWidth,
              0,
              Math.PI * 2,
              false
            );
            this.ctx.fill();
          }
          this.lastPos = this.mousePos;
        }
      },
      handleTouchstart(event) {
        this.mousePos = this.getTouchPos(event);
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousedown', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchend(event) {
        let mouseEvent = new MouseEvent('mouseup', {});
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchmove(event) {
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousemove', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      getMousePos(mouseEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top
        };
      },
      getTouchPos(touchEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top
        };
      },
      penColor(color) {
        this.ctx.strokeStyle = color;
      },
      clear() {
        this.canvas.width = this.canvas.width;
        this.isDrawing = false;
      },
      setDrawPostData(type) {
        if (type == 'pen') {
          this.isPen = true;
          this.isHidden = false;
          this.isDrawing = true;
        } else if (type == 'eraser') {
          this.isPen = false;
          this.isHidden = false;
        } else {
          this.isPen = false;
          this.isHidden = true;
        }
        this.isActive = type;
        this.updatePostData({ key: 'pemeriksaan_penunjang_is_draw', value: this.isDrawing });
      },
      addInputJenis() {
        const { jenisPemeriksaan } = this;
        const lastIndex = jenisPemeriksaan[jenisPemeriksaan.length - 1];
        const x = Object.keys(lastIndex);

        const tmp = x.reduce((obj, key) => {
          if (key === 'id') {
            obj[key] = jenisPemeriksaan.length + 1;
          } else if (key == 'qty') {
            obj[key] = 1;
          } else {
            obj[key] = null;
          }
          return obj;
        }, {});
        this.jenisPemeriksaan = [...jenisPemeriksaan, tmp];
      },
      removeJenis(index) {
        const { jenisPemeriksaan } = this;
        if (jenisPemeriksaan.length > 1) {
          const tmpJenis = jenisPemeriksaan;
          const tmp = tmpJenis
            .slice(0, index)
            .concat(tmpJenis.slice(index + 1, tmpJenis.length));
          this.jenisPemeriksaan = [...tmp];
          this.setInputJenis()
        }
      },
      getFilteredOptions(index) {
        return this.optionJenisPemeriksaan.filter(
          option => {
            let x = this.jenisPemeriksaan[index].selectedJenis ? this.jenisPemeriksaan[index].selectedJenis.value : null;
            return !this.selectedJenis.includes(option.value) || x === option.value
          }
        );
      },
      setInputJenis() {
        this.updatePostData({
          key: 'jenis_pemeriksaan',
          value: this.jenisPemeriksaan
        });
      },
      handleSelectedJenis(idx) {
        if (this.jenisPemeriksaan[idx].selectedJenis && this.jenisPemeriksaan[idx].selectedJenis.value == 'radiologiFoto') {
          this.selectedFilesIndex = []
        }
        this.jenisPemeriksaan[idx].hasil = null
        this.jenisPemeriksaan[idx].jenis_lain = null

        this.setInputJenis()
      },
      triggerFileInput(index) {
        this.$refs[`fileInput-${index}`][0].click();
      },
      triggerAction() {
        this.$refs['modal-camera'].show();
        this.activeCameraIndex = true
        this.$nextTick(this.onStartIndex)
      },
      onStartIndex() {
        if (this.$refs.webcamera) {
          this.$refs.webcamera.start();
        }   
      },
      onStopIndex() {
        this.$refs.webcamera.stop();
      },
      onCaptureIndex() {
        this.$refs['modal-camera'].hide()
        this.processWebcamImageIndex(this.$refs.webcamera.capture());
        this.activeCameraIndex = false
        this.onStopIndex();
      },
      closeModal() {
        this.$refs['modal-camera'].hide()
        this.activeCameraIndex = false
      },
      processWebcamImageIndex(x) {
        fetch(x)
          .then(res => res.blob())
          .then(blob => {
            this.selectedFilesIndex = Array(1).fill({
              name: `jenis_penunjang_${+new Date()}`,
              file: blob,
              size: blob.size
            });
          })
          .then(this.processUploadIndex);
      },
      async processUploadIndex() {
  
        if (this.selectedFilesIndex.length > 0) {
          this.selectedFilesIndex.map(item => {
            if (!item.isUploading && !item.from_api) {
              this.prepareUploadIndex(item.name, item.file);
              item.isUploading = true;
            }
          });
        }
  
        try {
          await Promise.all(this.promises).then(res => {
            res.map((item, index) => {
              if (!item.data.status) {
                return this.$swal({
                  type: 'error',
                  title: 'Oops...',
                  text: item.data.message
                }).then(() => {
                });
              } else {
                this.uploadedFilesIndex = res.reduce((unique, item) => {
                  return unique.includes(item.data) ? unique : [...unique, item.data];
                }, []);
              }
            });
          });
        } catch(e) {
        }
  
        if (this.selectedFilesIndex.length > 0) {
          this.selectedFilesIndex.map(item => {
            if (item.from_api) {
              this.uploadedFilesIndex.push(item)
            }
          });
        }
      },
      prepareUploadIndex(filename, file) {
        let formData = new FormData();
        formData.append('klinik_id', this.getKlinikId)
        formData.append(filename, file);

        this.promises.push(
          this.$axios.post('/upload-cloud', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: progressEvent => {
              let progress = (progressEvent.loaded * 100) / progressEvent.total;
              this.$set(this.fileProgress, filename, progress);
            }
          })
          .then(res => {
            if(res.data.status) this.uploadedFilesIndex.push(res.data)
          })
          .catch(e => {
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: `Gagal mengupload ${filename}`
            })
            .then(() => {
              let rmIndex = this.selectedFilesIndex.map(item => {
                return item.name;
              }).indexOf(filename);
              this.selectedFilesIndex.splice(rmIndex, 1);            
            })
          })
        );
      },
      async onFileSelectedIndex(event) {
        const {
          target: { files }
        } = event;
        this.fileReaderPromisesIndex = [];
  
        if (
          this.selectedFilesIndex.some(x =>
            Object.keys(files)
              .filter(item => item !== 'length')
              .some(item => files[item].name === x.name)
          )
        ) {
          this.$swal({
            type: 'error',
            text: 'Anda tidak bisa memasukkan data yang sama!'
          });
          return false;
        }
  
        var a = document.getElementsByClassName('file-upload-index');
        if (a.length + event.target.files.length > 1) {
          this.$swal({
            type: 'error',
            title: 'File Telah Mencapai Batas Maksimal',
            text: 'Anda hanya bisa mengunggah 1 file'
          });
          return;
        }
  
        for (let i = 0; i < event.target.files.length; i++) {
          if (i == 1 || this.selectedFilesIndex.length == 1) {
            this.$swal({
              type: 'error',
              title: 'File Telah Mencapai Batas Maksimal',
              text: 'Anda hanya bisa mengunggah 1 file'
            });
            return;
          }
          let file = event.target.files[i];
          let extension = file.name.split('.').pop();
  
          if (this.supportedFilesIndex.includes(extension.toLowerCase())) {
            if (this.isFileImage(file)) {
              this.compressImageIndex(file);
            } else {
              file = { name: file.name, file: file, size: file.size, from_api: false };
              this.selectedFilesIndex.push(file);
            }
          } else {
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text:
                'file ' +
                file.name +
                ' not supported, please upload jpeg, jpg, png file...'
            });
          }
        }
  
        await Promise.all(this.fileReaderPromisesIndex)
          .then(res => {
            res.map(item => {
              this.selectedFilesIndex.push(item);
            });
          })
          .then(this.processUploadIndex);
      },
      resetFileInputIndex(index) {
        const x = this.$refs[`fileInput-${index}`][0];
        x.value = '';
      },
      removeFileIndex(file, index) {
        this.selectedFilesIndex.splice(index, 1);
        this.promises.splice(index, 1);
        let filename = file.name;
        filename = filename.split(' ').join('_');
        filename = filename.split('.').join('_');

        let removeIndex = this.uploadedFilesIndex
            .map(item => {
              return item.name;
            })
            .indexOf(filename);
  
        if(file.from_api == true) {        
          const doDelete = this.$axios.post('/delete-cloud', {
            filenames: [file.uploaded_name]
          });

          doDelete.then(res => {
            this.uploadedFilesIndex.splice(removeIndex, 1);
          });
        } else {
  
          const doDelete = this.$axios.post('/delete-cloud', {
            filenames: [this.uploadedFilesIndex[removeIndex].uploaded_name]
          });
  
          doDelete.then(res => {
            this.uploadedFilesIndex.splice(removeIndex, 1);
          });
        }
      },
      compressImageIndex(file) {
        this.fileReaderPromisesIndex.push(
          new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onloadend = () => {
              let imageCompressor = new ImageCompressor({
                onSuccess: response => {
                  let ImageURL = response.compressed;
                  let block = ImageURL.split(';');
                  let contentType = block[0].split(':')[1];
                  let realData = block[1].split(',')[1];
                  let blob = this.b64toBlob(realData, contentType);
                  resolve({ name: file.name, file: blob, size: blob.size });
                },
                scale: 70,
                quality: 70,
                originalImage: reader.result
              });
            };
            reader.readAsDataURL(file);
          })
        );
      },
      onImageCapturedIndex(event) {
        //handle image from camera or from disk here...
        this.onFileSelectedIndex(event);
      },
    },
    mounted() {
      this.ctx = this.canvas.getContext('2d');
      this.ctx.strokeStyle = '#222222';
      this.ctx.lineWidth = this.penWidth;
      this.ctx.lineJoin = 'round';
      this.ctx.lineCap = 'round';
  
      //append data canvas to vuex global state
      this.updateCanvas({ key: 'PEMERIKSAAN_PENUNJANG', value: this.canvas });
      this.updatePostData({ key: 'pemeriksaan_penunjang_is_draw', value: false });
  
      // Get a regular interval for drawing to the screen
      window.requestAnimFrame = (function(callback) {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimaitonFrame ||
          function(callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();
      // Prevent scrolling when touching the canvas
      document.body.addEventListener(
        'touchstart',
        function(e) {
          if (
            e.target == document.getElementById('pemeriksaan_penunjang-canvas')
          ) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchend',
        function(e) {
          if (
            e.target == document.getElementById('pemeriksaan_penunjang-canvas')
          ) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchmove',
        function(e) {
          if (
            e.target == document.getElementById('pemeriksaan_penunjang-canvas')
          ) {
            e.preventDefault();
          }
        },
        false
      );
  
      this.ediRekamMedis = localStorage.getItem('edit_rekam_medis');
      if(this.ediRekamMedis != null) this.setPenunjangData(JSON.parse(this.ediRekamMedis));
    }
  };
</script>
  
<style scoped>  
  #pemeriksaan_penunjang-canvas {
    touch-action: none;
  }

  #upload-box {
    padding: 25px;
    border: 1px solid rgb(212, 212, 212);
    border-style: dashed;
    margin: 10px;
  }

  #upload-box-jenis {
    padding: 10px;
    border: 1px solid rgb(212, 212, 212);
    border-style: solid;
    margin-left: 2px;
    margin-right: 2px;
    border-radius: 5px;
  }

  .file-upload {
    padding: 25px;
    border: 1px solid rgb(212, 212, 212);
    background-color: rgb(250, 249, 245);
    margin: 10px;
  }

  .file-upload-index {
    padding: 5px;
    border: 1px solid rgb(212, 212, 212);
    border-radius: 5px;
    margin-left: 2px;
    margin-right: 2px;
  }
</style>

<style>
  .select_jenis_pemeriksaan
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
    color: #d1d2db !important;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  